<template>
    <div>
<!--        The department named <strong>{{ $_.get(activity, "payload.name") }}</strong> was added by-->
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong>.-->
        <span v-html="$t('notification.departmentAdded', { user: $_.get(activity, 'actorUser.name'), department:$_.get(activity, 'payload.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "DepartmentAdded",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
